import { Box } from "@material-ui/core"

export const LayoutContainer = ({ children }) => {

    return <Box sx={{ padding: "0 20px 0 20px", overflowY: "auto", scrollBehavior: "smooth", height: "inherit" }}>
        {children}
    </Box>
}